var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPath3376(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 408,
    height: 250,
    viewBox: "0 0 408 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M352.172 249.899H17.6916C14.0562 249.577 10.5728 247.978 7.65583 245.293C4.73888 242.608 2.51116 238.951 1.23771 234.755C-0.0531868 230.547 -0.341489 225.974 0.406572 221.572C1.15463 217.169 2.90816 213.12 5.46175 209.897L135.701 48.6404C148.177 33.2254 163.011 20.9925 179.35 12.6449C195.689 4.2974 213.209 0 230.905 0C248.6 0 266.121 4.2974 282.459 12.6449C298.798 20.9925 313.632 33.2254 326.108 48.6404L391.219 133.472C398.87 143.093 404.056 155.259 406.137 168.463C408.217 181.668 407.101 195.332 402.925 207.765C398.808 220.176 391.79 230.812 382.758 238.328C373.725 245.845 363.082 249.906 352.172 250V249.899Z",
    fill: "#00AEEF",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath3376);
export default __webpack_public_path__ + "static/media/Path 3376.e324d85f84e03e7c1072a80c16f0cc44.svg";
export { ForwardRef as ReactComponent };